import { DataTableEntityModel } from "src/store/models/entity/dataTable/entity";
import { DataTableHelperModel } from "src/store/models/entity/dataTable/helper";

export const encooDataTableModels = {
  entity: DataTableEntityModel,
  helper: DataTableHelperModel,
};
